import './style.scss';

import { Page } from 'components';
import Signin from 'components/ModalContent/Signin';
import { FC } from 'react';
import { Container } from 'react-bootstrap';

const Landing: FC = () => {
    return (
        <Page>
            <Container className="landing" fluid>
                <Signin />
            </Container>
        </Page>
    );
};

export default Landing;
